import React from 'react';
import { MeContext } from '../context/me';

export function useMe() {
  return React.useContext(MeContext);
}
